export function castEnumForDisplay(rawEnum) {
  if (!rawEnum) {
    return null;
  } else {
    const withSpaces = rawEnum.replace(/_/g, " ").toLowerCase();
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
  }
}
